// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    readLatestPerUnitMeasurements,
    resetLatestPerUnitMeasurements
} from '../../../shared/action-creators/latest-per-unit-measurements';
import actions from '../../action-list';
import {canGetProductCustomer} from '../../../shared/services/privacy';
import {findMatchingKey} from '../../shared/services/claim-shared-helper';
import {getDetails} from '../../../product/shared/repositories';
import {getUnitKey} from '../../shared/services/get-unit-key';
import {readCustomer} from './get-customer-details';
import {updateClaimUseAmountsArray} from '../../shared/services/update-claim-use-amounts-array';
import {updateResponsibleAccount} from '../services/update-responsible-account';

/* eslint-disable complexity */

export const readClaimProduct = (pin, resetUseAmounts) =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getDetails(pin);

            if (resetUseAmounts) {

                dispatch({
                    type: actions.RESET_CLAIM_PARTS_USE_AMOUNTS
                });

            }

            const productAccountId = data.dealer.account;
            const accountId = getState().claims.parts.claim.responsibleAccount.account;
            const dealerCollection = getState().user.details.settings.dealer.accounts.allowedAccounts;
            const useAmounts = getState().claims.parts.claim.useAmounts;
            const useAmountUnit = useAmounts.length ?
                useAmounts[0].unit.key : '';

            dispatch({
                data,
                type: actions.SET_CLAIM_PARTS_PRODUCT_DETAILS
            });

            if (!useAmountUnit && !data.complianceApplies) {

                const unitKey = getUnitKey(data);
                const useAmount = {
                    amount: '',
                    unit: findMatchingKey(unitKey, data.useAmountAllowedUnits)
                };

                dispatch({
                    type: actions.UPDATE_CLAIM_PARTS_USE_AMOUNT_ON_PRODUCT_LOAD,
                    useAmount
                });

            }

            updateResponsibleAccount(accountId, productAccountId, dealerCollection, pin)(dispatch);

            if (canGetProductCustomer(data)) {

                readCustomer(data.customerSummary.id, data.customerPrivate)(dispatch);

            }

            if (data.complianceApplies) {

                updateClaimUseAmountsArray(useAmounts, data.useAmountAllowedUnits, actions.UPDATE_CLAIM_PARTS_USE_AMOUNTS)(dispatch);

            }

            readLatestPerUnitMeasurements(pin)(dispatch);

        } catch (error) {

            dispatch({
                type: actions.RESET_CLAIM_PARTS_PRODUCT_DETAILS
            });

            resetLatestPerUnitMeasurements()(dispatch);

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/claim/parts/action-creators/get-product-details.js